import { Component, OnInit } from '@angular/core';
import { ApiService } from "../../../services/http/api.service";
import { ApiConfiguration } from "../../../services/http/api-configuration";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-visibility-config-edit',
  templateUrl: './visibility-config-edit.component.html',
  styleUrls: ['./visibility-config-edit.component.scss']
})
export class VisibilityConfigEditComponent implements OnInit {

  formData: any = [];
  id;

  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private activatedRoute: ActivatedRoute
  ) {
    this.id = this.activatedRoute.snapshot.paramMap.get('id')
  }

  ngOnInit() {
    this.getVisibilityData();
  }

  getVisibilityData() {
    this.apiService.getHeaders(this.apiConfig.getVisibilityConfig + '&posm_master_id=' + this.id)
      .subscribe((res: any) => {
        this.formData = res.body.data
        console.log(this.formData);
      }, err => {
        console.log(err);
      })
  }
}
